import { useEffect, useState } from "react";
import { IVrWorldContainerProps } from "./VrWorld.interfaces";
import VrWorldView from "./VrWorld.view";
import BroswerService from "../../Services/Browser.service";
export default function VrWorldContainer(props: IVrWorldContainerProps) {
    useEffect(() => {
        BroswerService.setCustomTitle("VrWorldContainer");
    }, []);
    const [showDemo, setShowDemo] = useState(false);
    const demoController = () => setShowDemo(!showDemo);
    const [showlogin, setShowlogin] = useState(false);
    const loginController = () => setShowlogin(!showlogin);
    return (
        <>
            <VrWorldView
                demoController={demoController}
                showDemo={showDemo}
                loginController={loginController}
                showlogin={showlogin}
            />
        </>
    );
}
